module.exports = __webpack_public_path__ + "static/media/visa.fe59af23.png";